import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteMBMAVOBBox, putMBMAVOBBox } from "services/ConfigServices";
import useAVOBBoxTable from "./useAVOBBoxTable.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { avobboxtext } from "variables/MBM/avobbox";
import { typeData } from "variables/MBM/lists/avobbox";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import AVOBBoxDialog from "./AVOBBoxDialog.js";
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import CloudSyncIcon from '@mui/icons-material/CloudSync';

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;
const ExpandableSubElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;
const ElementSubTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  margin-left: 10px;
  font-family: "Source Sans Pro",sans-serif;
`;
const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 13px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const StatusDiv = styled.div`
width: 32px;
height: 32px;
font-weight: 400;
font-size: 12px;
font-family: "Source Sans Pro",sans-serif;
`;

const useStyles2 = makeStyles((theme) => ({
  StatusOKIcon: {
    color: "#91c241",
    fontSize: "31px"
  },
  StatusWarningIcon: {
    color: "#FF763",
    fontSize: "31px"
  },
  StatusUnknownIcon: {
    color: "#605f70",
    fontSize: "31px"
  },
  StatusDangerIcon: {
    color: "#f44336",
    fontSize: "31px"
  },
}));

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTAVOBBox = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const currentusertype = localStorage.getItem('userType');
  const mbm_admin = permis.includes("mbm_admin") && currentusertype == 1; //not in prod yet
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [open, setOpen] = useState(false);
  const [currentAVOBBox, setCurrentAVOBBox] = useState(null);
  const { gridState, refetch, setAvobboxs } = useAVOBBoxTable();

  let dataAVOBBox = gridState.data;

  const classes = useStyles();
  const classes2 = useStyles2();
  const columns = [
    {
      name: avobboxtext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: avobboxtext.uniqueid,
      selector: (row) => row.uniqueid,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.uniqueid,
    },
    {
      name: avobboxtext.version,
      selector: (row) => row.version,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.version,
    },
    {
      name: avobboxtext.group,
      selector: (row) => row.groupid,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    {
      name: avobboxtext.lorawanstate,
      selector: (row) => row.lasthealth?.healthanalyse?.lorastate || 0,
      sortable: true,
      maxWidth: "6rem",
      cell: (row) => <Tooltip title={avobboxtext.lorawanstate}><StatusDiv>
        {
          row.lasthealth?.healthanalyse?.lorastate === 1 ?
            <CheckCircleOutlineIcon className={classes2.StatusOKIcon} fontSize="large" color="success" /> :
            row.lasthealth?.healthanalyse?.lorastate === 2 ?
              <WarningAmberIcon className={classes2.StatusWarningIcon} fontSize="large" color="warning" /> :
              row.lasthealth?.healthanalyse?.lorastate === 3 ?
                <CrisisAlertIcon className={classes2.StatusDangerIcon} fontSize="large" color="error" /> :
                <QuestionMarkIcon className={classes2.StatusUnknownIcon} fontSize="large" color="disabled" />
        }
      </StatusDiv></Tooltip>,
    },
    {
      name: avobboxtext.sessionstate,
      selector: (row) => row.lasthealth?.healthanalyse?.sessionstate || 0,
      sortable: true,
      maxWidth: "6rem",
      cell: (row) => <StatusDiv>
        {
          row.lasthealth?.healthanalyse?.sessionstate === 1 ?
            <CheckCircleOutlineIcon className={classes2.StatusOKIcon} fontSize="large" color="primary" /> :
            row.lasthealth?.healthanalyse?.sessionstate === 2 ?
              <WarningAmberIcon className={classes2.StatusWarningIcon} fontSize="large" color="warning" /> :
              row.lasthealth?.healthanalyse?.sessionstate === 3 ?
                <CrisisAlertIcon className={classes2.StatusDangerIcon} fontSize="large" color="error" /> :
                <QuestionMarkIcon className={classes2.StatusUnknownIcon} fontSize="large" color="disabled" />
        }
      </StatusDiv>,
    },
    {
      name: avobboxtext.diskspace,
      selector: (row) => row.lasthealth?.healthanalyse?.diskusage || 0,
      sortable: true,
      maxWidth: "6rem",
      cell: (row) => <StatusDiv>
        {
          row.lasthealth?.healthanalyse?.diskstate === 1 ?
            <CheckCircleOutlineIcon className={classes2.StatusOKIcon} fontSize="large" color="success" /> :
            row.lasthealth?.healthanalyse?.diskstate === 2 ?
              <WarningAmberIcon className={classes2.StatusWarningIcon} fontSize="large" color="warning" /> :
              row.lasthealth?.healthanalyse?.diskstate === 3 ?
                <CrisisAlertIcon className={classes2.StatusDangerIcon} fontSize="large" color="error" /> :
                <QuestionMarkIcon className={classes2.StatusUnknownIcon} fontSize="large" color="disabled" />
        }
      </StatusDiv>,
    },
    {
      name: avobboxtext.lasthealthdate,
      selector: (row) => row.lasthealthdate && moment(row.lasthealthdate).isValid() ? row.lasthealthdate : 0,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.lasthealthdate && moment(row.lasthealthdate).isValid()
          ? moment(row.lasthealthdate).format("DD/MM/YYYY HH:mm:ss")
          : "",
    },
    {
      name: avobboxtext.lastconnection,
      selector: (row) => row.lastconnection && moment(row.lastconnection).isValid() ? row.lastconnection : 0,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.lastconnection && moment(row.lastconnection).isValid()
          ? moment(row.lastconnection).format("DD/MM/YYYY HH:mm:ss")
          : "",
    },
    {
      name: "",
      sortable: false,
      width: "12rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {mbm_admin && (
              <>
                <Tooltip title={avobboxtext.edit}>
                  <Button
                    onClick={editAVOBBox(row)}
                    color={"warning"}
                    className={classes.actionButton}
                  >
                    <EditIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title={avobboxtext.push}>
                  <Button
                    onClick={pushAVOBBoxFunction(row)}
                    color={"info"}
                    className={classes.actionButton}
                  >
                    <CloudSyncIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title={avobboxtext.delete}>
                  <CustomDeleteButton
                    deleteTitle={"Suppression de la box"}
                    deleteSubTitle={`Êtes-vous sûr de vouloir supprimer la box' ${row.name}?`}
                    handleSupprimer={deleteAVOBBoxFunction(row)}
                  />
                </Tooltip></>
            )}
          </div>
        </>
      ),
    },
  ];

  const ExpandableComponent = props => {
    const { data } = props;
    const SubTabs = () => {
      return (
        <>
          <div>
            <ExpandableContainer>
              <ElementSubTitle>{avobboxtext.description}</ElementSubTitle>
              <ElementData>{data.description}</ElementData>
            </ExpandableContainer>
            
            <ExpandableContainer>
              <ElementTitle>{avobboxtext.healthanalyse}</ElementTitle>
              <ExpandableElement>
                <ElementSubTitle>{avobboxtext.diskusage} : </ElementSubTitle>
                <ElementData>{data.lasthealth?.healthanalyse?.diskusage}%</ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementSubTitle>{avobboxtext.sessionup} : </ElementSubTitle>
                <ElementData>{data.lasthealth?.healthanalyse?.sessionup}</ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementSubTitle>{avobboxtext.sessiondown} : </ElementSubTitle>
                <ElementData>{data.lasthealth?.healthanalyse?.sessiondown}</ElementData>
              </ExpandableElement>
            </ExpandableContainer>

            <ExpandableContainer>
              <ElementTitle>{avobboxtext.lorawanstate}</ElementTitle>
              <ExpandableElement>
                <ElementSubTitle>{avobboxtext.lorawangatewayup} : </ElementSubTitle>
                <ElementData>{data.lasthealth?.healthanalyse?.gatewayup}</ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementSubTitle>{avobboxtext.lorawangatewaydown} : </ElementSubTitle>
                <ElementData>{data.lasthealth?.healthanalyse?.gatewaydown}</ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementSubTitle>{avobboxtext.chirpstackrestapi} : </ElementSubTitle>
                <ElementData>{data.lasthealth?.['chirpstack-rest-api']?.health == 1 ? 'OK' : 'KO'}</ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementSubTitle>{avobboxtext.chirpstackapp} : </ElementSubTitle>
                <ElementData>{data.lasthealth?.system?.services?.['chirpstack-app'] == 1 ? 'OK' : 'KO'}</ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementSubTitle>{avobboxtext.chirpstackbridge} : </ElementSubTitle>
                <ElementData>{data.lasthealth?.system?.services?.['chirpstack-bridge'] == 1 ? 'OK' : 'KO'}</ElementData>
              </ExpandableElement>
              <ExpandableElement>
                <ElementSubTitle>{avobboxtext.postgres} : </ElementSubTitle>
                <ElementData>{data.lasthealth?.system?.services?.['postgres'] == 1 ? 'OK' : 'KO'}</ElementData>
              </ExpandableElement>
            </ExpandableContainer>

            <ExpandableContainer>
              <ElementTitle>{avobboxtext.lorawangateway}</ElementTitle>
              {
                data.lasthealth?.['chirpstack-rest-api']?.gateways ? data.lasthealth['chirpstack-rest-api'].gateways.map((gateway) => {
                  let lastseen = gateway.lastSeenAt;
                  lastseen = lastseen.replace("\\/", "/");
                  return (<ExpandableElement>
                    <ElementSubTitle>{gateway.euid} : </ElementSubTitle>
                    <ElementData>{lastseen}</ElementData>
                  </ExpandableElement>)
                }) : <></>
              }
            </ExpandableContainer>

            <ExpandableContainer>
              <ElementTitle>{avobboxtext.sessionstate}</ElementTitle>
              {
                data.lasthealth?.sessions ? data.lasthealth.sessions.map((session) => {
                  let sessionname = data.sessions?.find((sess) => sess.id == session.id)?.name;
                  return (<ExpandableElement>
                    <ElementSubTitle>{sessionname} : </ElementSubTitle>
                    <ElementData>{session.state == 1 ? 'OK' : 'KO'}</ElementData>
                  </ExpandableElement>)
                }) : <></>
              }
            </ExpandableContainer>
          </div>

        </>
      );
    };
    return (
      <Container>
        <ExpandableContainer>
          <div>
            <SubTabs />
          </div>
        </ExpandableContainer>
      </Container>
    );
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const pushAVOBBoxFunction = (row) => async () => {
    let obj = dataAVOBBox.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = putMBMAVOBBox(idSelected, "push");
    axios
      .put(url,
        {},
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `La box a été synchronisée`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const editAVOBBox = (row) => async () => {
    let obj = dataAVOBBox.find((o) => o.id === row.id);
    if (obj) {
      setCurrentAVOBBox(obj);
      handleClickOpen();
    }
  }

  const deleteAVOBBoxFunction = (row) => async () => {
    let obj = dataAVOBBox.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let type = obj.type;
    let url = deleteMBMAVOBBox(idSelected, type);
    axios
      .delete(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `La box a été supprimée`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setAvobboxs(selection.selectedRows);
  };


  return (
    <>
      <DataTable
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        noDataComponent={<NoData>Aucune Box à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        expandOnRowClicked
        expandableRows={mbm_admin}
        expandableRowsComponent={ExpandableComponent}
        expandableRowDisabled={(row) => row.disabled}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          Modification d'une box
        </CustomDialogTitle>
        <DialogContent dividers>
          <AVOBBoxDialog
            currentBox={currentAVOBBox}
            closeModal={handleEditClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTAVOBBox;
